export default "__VITE_ASSET__6841189d__"